type AssetProps = Omit<
    React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
    "src"
> & { src: string };

export function Asset(props: AssetProps) {
    return <img {...props} />;
}
